import type { ExcursionsData } from '../../domain/types'
import type { ExcursionsAPIResponse } from '../types'

export function excursionsMapper(apiResponse: ExcursionsAPIResponse): ExcursionsData {
  return {
    excursions: (apiResponse.excursions ?? []).filter(item => item.url).map(item => ({
      title: item.title ?? '',
      subtitle: item.subtitle ?? '',
      url: item.url as string,
      imageUrl: item.imageUrl ?? '',
    })),
    allExcursionsLink: apiResponse.allExcursionsLink ?? '',
  }
}
